export default {
  CodigoAcesso: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "codigo-acesso"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CodigoAcesso.js
// module id = 3SgC
// module chunks = 18